import React from 'react';
import { css, styled } from '~ui-kit/styled-components';
import { Box, BoxProps } from '../box/box';

interface CardProps extends BoxProps {
  elevation?: 1;
}

export function Card({ children, elevation, ...props }: CardProps) {
  return (
    <Container p={4} flexDirection="column" $elevation={elevation} {...props}>
      {children}
    </Container>
  );
}

const Container = styled(Box)<{ $elevation: number }>`
  border-radius: 4px;

  ${(props) =>
    ({
      1: css`
        box-shadow:
          0px 1px 3px 0px #0000001f,
          0px 1px 1px 0px #00000024,
          0px 2px 1px -1px #00000033;
      `,
      default: css`
        box-shadow: 0px 4px 10px 0px #00000012;
      `,
    })[props.$elevation || 'default']}
`;
